import { inject, NewInstance } from 'aurelia-framework';
import { CustomerService } from 'pages/quote-setup/customers/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), CustomerService, EventAggregator)
export class CustomerEditor {
    constructor(controller, validationController, customerService, ea) {
        this.controller = controller;
        this.customerService = customerService;
        this.ea = ea;
        this.customer = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .ensure('address').required()
            .ensure('city').required()
            .ensure('state').required()
            .ensure('country').required()
            .ensure('sga').required()
            .ensure('profit').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.customer = await this.customerService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.customer.id) {
                    await this.customerService.update(this.customer);
                    toastr.success('Customer was updated!');
                } else {
                    await this.customerService.create(this.customer);
                    toastr.success('New customer was created!');
                }
                this.ea.publish('customers:updated', this.customer);
                this.controller.ok(this.customer);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}